export default __webpack_public_path__ + "static/media/orgs-group.72389c77.png";